import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDisputeCategoriesThunk,
  fetchEscalationSettingsThunk,
  fetchEscalationTatConfigsThunk,
  upsertEscalationTatConfigThunk,
} from "../thunks/disputeEscalationConfigThunks";

const initialState = {
  configs: [],
  categories: [],
  settings: null,
  loading: false,
  settingsLoading: false,
  saving: false,
  error: null,
};

const disputeEscalationConfigSlice = createSlice({
  name: "disputeEscalationConfig",
  initialState,
  reducers: {
    clearEscalationConfigError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEscalationTatConfigsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEscalationTatConfigsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.configs = action.payload || [];
      })
      .addCase(fetchEscalationTatConfigsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(upsertEscalationTatConfigThunk.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(upsertEscalationTatConfigThunk.fulfilled, (state) => {
        state.saving = false;
      })
      .addCase(upsertEscalationTatConfigThunk.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      })

      .addCase(fetchEscalationSettingsThunk.pending, (state) => {
        state.settingsLoading = true;
      })
      .addCase(fetchEscalationSettingsThunk.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = action.payload;
      })
      .addCase(fetchEscalationSettingsThunk.rejected, (state, action) => {
        state.settingsLoading = false;
        state.error = action.payload;
      })

      .addCase(fetchDisputeCategoriesThunk.fulfilled, (state, action) => {
        state.categories = action.payload || [];
      });
  },
});

export const { clearEscalationConfigError } =
  disputeEscalationConfigSlice.actions;
export default disputeEscalationConfigSlice.reducer;
